import './Gallery.css'

function Gallery ({images, initialDisplayCountMobile=1}) {
  return (
    <div className="columns">
      <div className="column is-1 is-hidden-mobile"></div>
      {images.map((image, i) => {
        
        let isHiddenMobileClass = i+1 > initialDisplayCountMobile ? 'is-hidden-mobile' : '';

        return (
          
          <div key={i} className={`column is-2 ${isHiddenMobileClass}`}>
            <img src={image} alt={`C3 Tubular ${i}`}></img>
          </div>
        )
      })}
    </div>
  );
}


export default Gallery;